<template>
  <div class="sign-active">
    <div class="box">
      <div class="box-template" v-for="(context,index) in contexts" :key="index">
        <div class="title">{{context.tittle}}</div>
        <div class="theme">
          会议主题:
          <span>{{context.title}}</span>
        </div>
        <div class="time">
          会议事件:
          <span>{{context.typename}}</span>
        </div>
        <!-- <div class="bodys">
          会议人员:
          <span>{{context.bodys}}</span>
        </div> -->
        <div class="bodys">
          会议地点:
          <span>{{context.address}}</span>
        </div>
        <div class="submit">
          <button @click="goSign(context.id,context.uid)">确认签到</button>
          <button @click="notSign(context.id,context.uid)">缺席未到</button>
        </div>
        <!-- <div class="submit" v-if="!context.state">
          <button class="nosign">已签到</button>
        </div> -->
      </div>
    </div>

    <div class="motai" v-if="motai.motai==1?true:false">
      <div class="sign" v-if="motai.signs==1?true:false">
        <img src="@/assets/partyhome/threeClass/dp-dy-sh9.png" />
        <p>感谢您的到来，签到成功~</p>
        <button @click="fade">我知道了</button>
      </div>
      <div class="dove" v-if="motai.signs==2?true:false">
        <img src="@/assets/partyhome/threeClass/dp-dy-sh10.png" />
        <p>请填写缺席原因</p>
        <el-input
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 5}"
          placeholder="请输入缺席理由"
          v-model="text"
        ></el-input>
        <button @click="noShows">确认提交</button>
        <i class="el-icon-circle-close" @click="motai.motai=0"></i>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      contexts: [
        // {
        //   title: "三会一课【党组小会】",
        //   theme: "扫黑除恶",
        //   time: "扫黑除恶",
        //   bodys: "团结村党委成员全体",
        //   adress: "团结村党委办公室",
        //   state: false
        // },
        // {
        //   title: "三会一课【党组小会】",
        //   theme: "扫黑除恶",
        //   time: "扫黑除恶",
        //   bodys: "团结村党委成员全体",
        //   adress: "团结村党委办公室",
        //   state: true
        // }
      ],
      motai: {
        motai: 0,
        signs: 0
      },
      text: "",
      id:"",
      uid:"",
    };
  },
  methods: {
    goSign(id,uid) {
      this.motai.motai = 1;
      this.motai.signs = 1;
      this.axios.post(
        '/api/Party/Join',
        {id:id*1,uid:uid*1,title:sessionStorage.getItem('token')}
      ).then(e=>{
        console.log(e.data);
        if(e.data.code==0){
          // this.$router.go(0)
        }
      }).catch(err=>{
        console.log(err);
        
      })
    },
    notSign(id,uid) {
      this.motai.motai = 1;
      this.motai.signs = 2;
      this.id = id;
      this.uid = uid
    },
    fade() {
      this.motai.motai = 0;
      this.motai.signs = 0;
    },
    getMsg(){
      this.axios.post(
        '/api/Party/Sign',
        {title:sessionStorage.getItem('token')}
      ).then(e=>{
        console.log(e.data);
        switch (e.data.code) {
          case 0:
            this.contexts = e.data.msg
            break;
        
          default:alert(e.data.msg)
            break;
        }
      }).catch(err=>{
        console.log(err);
        
      })
    },
    noShows(){
      this.fade()
      this.axios.post(
        '/api/Party/NoJoin',
        {id:this.id*1,uid:this.uid*1,title:sessionStorage.getItem('token'),memo:this.text}
      ).then(e=>{
        if(e.data.code==0){
          // this.$router.go(0)
        }
      })
    }
  },
  mounted(){
    this.getMsg()
  },
};
</script>

<style lang="scss" scoped>
.sign-active {
  .motai {
    .dove {
      .el-textarea {
        width: 70%;
        position: absolute;
        top: 4rem;
        left: 15%;
      }
      img {
        width: 80%;
        height: 100%;
      }
      i{
        position: absolute;
        color: #fff;
        font-size: .7rem;
        bottom: -.8rem;
        left: 44%;
      }
      text-align: center;
      margin-top: 15vh;
      position: relative;
    }
    .sign {
      img {
        width: 80%;
        height: 100%;
      }
      text-align: center;
      margin-top: 20vh;
      position: relative;
    }
    p {
      color: #fff;
      font-size: 0.36rem;
      position: absolute;
      width: 100%;
      top: 3.2rem;
    }
    button {
      border: 0;
      box-shadow: 0.01rem 0.1rem 0.1rem 0px rgba(249, 186, 79, 0.1);
      border-radius: 0.4rem;
      padding: 0.2rem 1rem;
      background-image: linear-gradient(1deg, #f9b94d 0%, #fdcb76 100%);
      color: #fff;
      font-size: 0.3rem;
      position: absolute;
      bottom: .6rem;
      left: 28%;
    }
    width: 100%;
    background: rgba(0, 0, 0, 0.2);
    position: fixed;
    top: 0;
    height: 100vh;
  }
  .box {
    .box-template {
      .submit {
        .nosign {
          background: #eeeeee !important;
          color: #999999;
        }
        button {
          &:nth-child(1) {
            background-image: linear-gradient(250deg, #f9b94d 0%, #fdcb76 100%),
              linear-gradient(-70deg, #fb3f3f 0%, #fe5f5f 100%);
          }
          &:nth-child(2) {
            background-image: linear-gradient(-70deg, #fb3f3f 0%, #fe5f5f 100%);
          }
          margin-right: 0.4rem;
          padding: 0.1rem 0.3rem;
          border-radius: 0.04rem;
          border: 0;
          color: #fff;
          font-size: 0.26rem;
        }
      }
      .title {
        color: #000;
      }
      div {
        span {
          color: #000;
        }
        padding: 0.2rem 0.3rem;
        color: #999999;
      }
      width: 90%;
      margin: 0.3rem auto;
      border-top: 0.16rem solid #f9b94d;
      border-radius: 0.08rem;
      box-shadow: 0px 0.06rem 0.06rem 0px rgba(0, 0, 0, 0.06);
    }
  }
  background: #fff;
  min-height: 100vh;
  padding-top: 1rem;
  font-size: 0.3rem;
}
</style>


<style lang="scss">
.sign-active{
  .motai{
    textarea{
      font-size: .3rem;
    }
  }
}
</style>